<template>
  <div id="autocomplete" class="autocomplete">
    <input
      type="text"
      class="form-control"
      @input="onChange"
      v-model="search"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
    />
    <ul
      id="autocomplete-results"
      v-show="isOpen"
      class="autocomplete-results"
    >
      <li
        class="loading"
        v-if="isLoading"
      >
        Loading results...
      </li>
      <li
        v-else
        v-for="(result, i) in results"
        :key="i"
        @click="setResult(result)"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter }"
      >
        {{ result }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'AutoComplete',
    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
      isAsync: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        isOpen: false,
        results: [],
        search: '',
        isLoading: false,
        arrowCounter: -1,
      };
    },
    watch: {
      items: function (value, oldValue) {
        if (value.length !== oldValue.length) {
          this.results = value;
          this.isLoading = false;
        }
      },
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside)
    },
    destroyed() {
      document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        clearSearch() {
            this.search = '';
        },
      setResult(result) {
        this.search = result;
        this.isOpen = false;
        this.$emit('makeInput', this.search);
      },
      filterResults() {
        this.results = this.items.filter((item) => {
          return item.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });
      },
      onChange() {
        this.$emit('makeInput', this.search);

        if (this.isAsync) {
          this.isLoading = true;
        } else {
          this.filterResults();
          this.isOpen = true;
        }
      },
      handleClickOutside(event) {
        if (!this.$el.contains(event.target)) {
          this.isOpen = false;
          this.arrowCounter = -1;
        }
      },
      onArrowDown() {
        if (this.arrowCounter < this.results.length) {
          this.arrowCounter = this.arrowCounter + 1;
        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1;
        }
      },
      onEnter() {
        this.search = this.results[this.arrowCounter];
        this.isOpen = false;
        this.arrowCounter = -1;
      },
    },
  };
</script>

<style lang="scss">
@import '../assets/global.scss';

  #autocomplete {
    position: relative;
  }

  //bootstrap styles
    #autocomplete .form-control {
        display: block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 1rem !important;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    #autocomplete input {
      overflow: visible;
      margin: 0;
    }

  //bootstrap styles

  #autocomplete .form-control {
    border-radius: 0 !important;
    border-color: $ltgray !important;
    background-color: #fff !important;
    margin-bottom: 0 !important;
    min-height: auto !important;
  }

  #autocomplete .autocomplete-results {
    padding: 0 !important;
    margin: 0 !important;
    border: 1px solid $ltgray !important;
    background-color: white !important;
    /* height: 120px; */
    width: 100% !important;
    overflow: auto !important;
    position: absolute !important;
    z-index: 100 !important;
  }

  #autocomplete .autocomplete-result {
    list-style: none !important;
    text-align: left !important;
    padding: 4px 2px !important;
    cursor: pointer !important;
  }

  #autocomplete .autocomplete-result.is-active,
  #autocomplete .autocomplete-result:hover {
    background-color: lighten($blue, 50) !important;
    color: white !important;
  }
</style>